import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check, X } from '../components/Icons.jsx';

const gradeMap = { 'A*': 56, 'A': 48, 'B': 40, 'C': 32, 'D': 24, 'E': 16 };

const UCAT_SOURCE = 'https://www.medicmind.co.uk/medicine-ucas-guide/ucat-cut-off-scores/';

const schools = [
  { name: 'University of Oxford', alevels: 'A*AA', ib: { total: 39, hl: [7, 6, 6] }, ucat: 2780, chem: true, bio: true, source: 'https://www.medsci.ox.ac.uk/study/medicine' },
  { name: 'University of Cambridge', alevels: 'A*A*A', ib: { total: 40, hl: [7, 7, 6] }, ucat: 2780, chem: true, bio: true, source: 'https://www.medschl.cam.ac.uk/admissions/' },
  { name: 'Imperial College London', alevels: 'AAA', ib: { total: 38, hl: [6, 6, 6] }, ucat: 2700, chem: true, bio: true, gcse: 'Mostly 7+', source: 'https://www.imperial.ac.uk/medicine/study/undergraduate/' },
  { name: 'UCL', alevels: 'A*AA', ib: { total: 39, hl: [6, 6, 6] }, ucat: 2650, chem: true, bio: true, gcse: 'Mostly 6+', source: 'https://www.ucl.ac.uk/medical-school/study/mbbs' },
  { name: "King's College London", alevels: 'A*AA', ib: { total: 35, hl: [6, 6, 6] }, ucat: 2620, chem: true, bio: true, source: 'https://www.kcl.ac.uk/study/undergraduate/courses/medicine-mbbs' },
  { name: 'Manchester', alevels: 'AAA', ib: { total: 37, hl: [6, 6, 6] }, ucat: 2550, chem: true, bio: true, gcse: '7 GCSEs at 6+', source: 'https://www.manchester.ac.uk/study/undergraduate/courses/2026/00472/mbchb-medicine/' },
  { name: 'Edinburgh', alevels: 'AAA', ib: { total: 37, hl: [6, 6, 6] }, ucat: 2700, chem: true, bio: false, gcse: 'Mostly 7+', source: 'https://www.ed.ac.uk/medicine-vet-medicine/medical-school' },
  { name: 'Bristol', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2470, chem: true, bio: true, source: 'https://www.bristol.ac.uk/medical-school/undergraduate/' },
  { name: 'Birmingham', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2530, chem: true, bio: true, gcse: '7 GCSEs incl. EngLang at 7+', source: 'https://www.birmingham.ac.uk/study/undergraduate/subjects/medicine/medicine-and-surgery-mbchb' },
  { name: 'Newcastle', alevels: 'AAA', ib: { total: 35, hl: [5, 5, 5] }, ucat: 2440, chem: true, bio: true, source: 'https://www.ncl.ac.uk/undergraduate/degrees/a100/' },
  { name: 'Sheffield', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2500, chem: true, bio: true, gcse: '6 GCSEs at 6+', source: 'https://www.sheffield.ac.uk/medicine/study-medicine' },
  { name: 'Leeds', alevels: 'AAA', ib: { total: 35, hl: [6, 6, 5] }, ucat: 2490, chem: true, bio: true, source: 'https://courses.leeds.ac.uk/c008/medicine-and-surgery-mbchb-bs' },
  { name: 'Cardiff', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2530, chem: true, bio: true, source: 'https://www.cardiff.ac.uk/study/undergraduate/courses/2026/medicine-mbbch' },
  { name: 'Nottingham', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2450, chem: true, bio: true, source: 'https://www.nottingham.ac.uk/medicine/' },
  { name: 'Southampton', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2380, chem: true, bio: true, source: 'https://www.southampton.ac.uk/courses/medicine-degree-bm' },
  { name: 'Leicester', alevels: 'AAA', ib: { total: 32, hl: [6, 6, 5] }, ucat: 2420, chem: true, bio: true, source: 'https://le.ac.uk/courses/medicine-mbchb/' },
  { name: 'Liverpool', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2520, chem: true, bio: true, source: 'https://www.liverpool.ac.uk/study/undergraduate/courses/medicine-and-surgery-mbchb/' },
  { name: 'Glasgow', alevels: 'AAA', ib: { total: 38, hl: [6, 6, 6] }, ucat: 2570, chem: true, bio: true, source: 'https://www.gla.ac.uk/undergraduate/degrees/medicine/' },
  { name: 'Aberdeen', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2400, chem: true, bio: true, source: 'https://www.abdn.ac.uk/study/undergraduate/degree-programmes/medicine-2410' },
  { name: 'Dundee', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2480, chem: true, bio: true, source: 'https://www.dundee.ac.uk/undergraduate/medicine-mbchb' },
  { name: 'Queen Mary (Barts)', alevels: 'A*AA', ib: { total: 38, hl: [6, 6, 6] }, ucat: 2580, chem: true, bio: true, source: 'https://www.qmul.ac.uk/medicine/undergraduate-medicine/' },
  { name: "St George's, London", alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2400, chem: true, bio: true, source: 'https://www.sgul.ac.uk/study/courses/undergraduate-medicine' },
  { name: 'Lancaster', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2400, chem: true, bio: true, source: 'https://www.lancaster.ac.uk/study/undergraduate/courses/medicine-and-surgery-mbchb/' },
  { name: 'Hull York', alevels: 'AAA', ib: { total: 35, hl: [6, 6, 5] }, ucat: 2370, chem: true, bio: true, source: 'https://www.hyms.ac.uk/study-medicine' },
  { name: 'Plymouth', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2420, chem: true, bio: true, source: 'https://www.plymouth.ac.uk/courses/undergraduate/bmbs-medicine' },
  { name: 'Exeter', alevels: 'AAA', ib: { total: 36, hl: [6, 6, 6] }, ucat: 2440, chem: true, bio: true, source: 'https://medicine.exeter.ac.uk/study/undergraduate/medicine/' },
  { name: 'UEA', alevels: 'AAA', ib: { total: 34, hl: [6, 6, 5] }, ucat: 2380, chem: true, bio: true, source: 'https://www.uea.ac.uk/course/medicine' },
  { name: 'Sunderland', alevels: 'AAA', ib: { total: 32, hl: [5, 5, 5] }, ucat: 2330, chem: true, bio: true, source: 'https://www.sunderland.ac.uk/study/medicine' }
];

function parseAlevels(g1, g2, g3) {
  const grades = [g1, g2, g3].map((g) => g.toUpperCase());
  const points = grades.map((g) => gradeMap[g] || 0).sort((a, b) => b - a);
  return { points, sorted: grades.slice().sort((a, b) => (gradeMap[b] || 0) - (gradeMap[a] || 0)) };
}

function alevelsMeet(req, points) {
  const reqMap = { 'A*A*A': [56, 56, 48], 'A*AA': [56, 48, 48], 'AAA': [48, 48, 48], 'AAB': [48, 48, 40] };
  const target = reqMap[req] || [48, 48, 48];
  for (let i = 0; i < 3; i++) if (points[i] < target[i]) return false;
  return true;
}

function ibMeet(req, total, hl) {
  if (total < req.total) return false;
  const sortedHl = [...hl].sort((a, b) => b - a);
  const sortedReq = [...req.hl].sort((a, b) => b - a);
  for (let i = 0; i < 3; i++) if (sortedHl[i] < sortedReq[i]) return false;
  return true;
}

function ibLabel(req) {
  return `${req.total} (${req.hl.join(',')} HL)`;
}

export default function GradeCheck() {
  const [qual, setQual] = useState('alevel');
  const [g1, setG1] = useState('A');
  const [g2, setG2] = useState('A');
  const [g3, setG3] = useState('A');
  const [ibTotal, setIbTotal] = useState(36);
  const [ibHl, setIbHl] = useState([6, 6, 6]);
  const [chem, setChem] = useState(true);
  const [bio, setBio] = useState(true);
  const [gcseNines, setGcseNines] = useState(3);
  const [gcseSevens, setGcseSevens] = useState(5);
  const [ucat, setUcat] = useState(2500);

  const parsed = useMemo(() => parseAlevels(g1, g2, g3), [g1, g2, g3]);

  const verdicts = useMemo(() => {
    return schools.map((s) => {
      const qualOk = qual === 'alevel' ? alevelsMeet(s.alevels, parsed.points) : ibMeet(s.ib, ibTotal, ibHl);
      const subOk = (!s.chem || chem) && (!s.bio || bio);
      const ucatOk = ucat >= s.ucat;
      const ucatClose = ucat >= s.ucat - 100;
      let verdict, ord;
      if (qualOk && subOk && ucatOk) { verdict = 'Eligible'; ord = 0; }
      else if (qualOk && subOk && ucatClose) { verdict = 'Borderline'; ord = 1; }
      else if (!subOk) { verdict = 'Missing subject'; ord = 3; }
      else if (!qualOk) { verdict = qual === 'alevel' ? 'Grades short' : 'IB score short'; ord = 4; }
      else { verdict = 'UCAT too low'; ord = 2; }
      return { ...s, verdict, ord };
    }).sort((a, b) => a.ord - b.ord);
  }, [qual, parsed.points, ibTotal, ibHl, chem, bio, ucat]);

  const counts = useMemo(() => {
    const c = { Eligible: 0, Borderline: 0, Other: 0 };
    for (const v of verdicts) {
      if (v.verdict === 'Eligible') c.Eligible++;
      else if (v.verdict === 'Borderline') c.Borderline++;
      else c.Other++;
    }
    return c;
  }, [verdicts]);

  return (
    <>
      <div className="page-head">
        <h1>Grade check</h1>
        <p className="subtitle">Will your grades clear the entry bar at each UK med school?</p>
      </div>

      <div className="card" style={{ marginBottom: 18 }}>
        <h3 style={{ margin: '0 0 12px', fontSize: 18 }}>Qualification</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 18 }}>
          <SegmentBtn active={qual === 'alevel'} onClick={() => setQual('alevel')}>A-levels</SegmentBtn>
          <SegmentBtn active={qual === 'ib'} onClick={() => setQual('ib')}>IB Diploma</SegmentBtn>
        </div>

        {qual === 'alevel' ? (
          <>
            <h3 style={{ margin: '0 0 10px', fontSize: 18 }}>Your A-level predictions</h3>
            <div className="r-grid-3" style={{ gap: 12 }}>
              <GradeSelect label="Subject 1" value={g1} onChange={setG1} />
              <GradeSelect label="Subject 2" value={g2} onChange={setG2} />
              <GradeSelect label="Subject 3" value={g3} onChange={setG3} />
            </div>
          </>
        ) : (
          <>
            <h3 style={{ margin: '0 0 10px', fontSize: 18 }}>Your IB predictions</h3>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-2)' }}>Total points (out of 45)</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 6 }}>
                <input type="range" min="24" max="45" step="1" value={ibTotal} onChange={(e) => setIbTotal(Number(e.target.value))} style={{ flex: 1, accentColor: 'var(--brand-purple)' }} />
                <input type="number" min="24" max="45" value={ibTotal} onChange={(e) => setIbTotal(Math.max(24, Math.min(45, Number(e.target.value) || 0)))} style={{ width: 80, padding: '8px 10px', fontSize: 16, fontWeight: 700, border: '1px solid var(--border-strong)', borderRadius: 8, textAlign: 'right' }} />
              </div>
            </div>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-2)' }}>Three Higher Level grades (1–7)</label>
            <div className="r-grid-3" style={{ gap: 12, marginTop: 6 }}>
              {[0, 1, 2].map((i) => (
                <IbHlSelect key={i} label={`HL ${i + 1}`} value={ibHl[i]} onChange={(v) => { const next = [...ibHl]; next[i] = v; setIbHl(next); }} />
              ))}
            </div>
          </>
        )}

        <h3 style={{ margin: '20px 0 10px', fontSize: 18 }}>Subjects taken</h3>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          <Toggle label={qual === 'alevel' ? 'Chemistry A-level' : 'Chemistry (HL preferred)'} on={chem} onChange={setChem} />
          <Toggle label={qual === 'alevel' ? 'Biology A-level' : 'Biology (HL preferred)'} on={bio} onChange={setBio} />
        </div>

        <h3 style={{ margin: '20px 0 10px', fontSize: 18 }}>GCSEs (approximate)</h3>
        <div className="r-grid-2" style={{ gap: 12 }}>
          <NumberField label="Number of 9s" value={gcseNines} onChange={setGcseNines} max={12} />
          <NumberField label="Number of 7s and 8s" value={gcseSevens} onChange={setGcseSevens} max={12} />
        </div>

        <h3 style={{ margin: '20px 0 10px', fontSize: 18 }}>UCAT total (VR + DM + QR)</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <input type="range" min="1800" max="2700" step="10" value={ucat} onChange={(e) => setUcat(Number(e.target.value))} style={{ flex: 1, accentColor: 'var(--brand-purple)' }} />
          <input type="number" min="1800" max="2700" value={ucat} onChange={(e) => setUcat(Math.max(1800, Math.min(2700, Number(e.target.value) || 0)))} style={{ width: 90, padding: '8px 10px', fontSize: 16, fontWeight: 700, border: '1px solid var(--border-strong)', borderRadius: 8, textAlign: 'right' }} />
        </div>
      </div>

      <div className="card" style={{ marginBottom: 18, borderLeft: '5px solid var(--brand-purple)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 24 }}>You meet entry requirements at <span style={{ color: 'var(--brand-purple)' }}>{counts.Eligible}</span> of 28 schools</h2>
            <p style={{ margin: '4px 0 0', color: 'var(--text-muted)' }}>+ {counts.Borderline} more where you're borderline.</p>
          </div>
          <Link to="/where-can-i-apply" className="btn btn-primary">See full UCAT view <ArrowRight width="16" height="16" /></Link>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-scroll">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: 'var(--card-soft)' }}>
              <th style={cellHead}>School</th>
              <th style={cellHead}>{qual === 'alevel' ? 'A-level required' : 'IB required'}</th>
              <th style={cellHead}>
                UCAT cutoff
                <InfoIcon href={UCAT_SOURCE} label="UCAT cutoffs aggregated by Medic Mind from prior-cycle decile data. Universities don't publish a formal UCAT cutoff." />
              </th>
              <th style={cellHead}>Subjects</th>
              <th style={cellHead}>Verdict</th>
            </tr>
          </thead>
          <tbody>
            {verdicts.map((v) => (
              <tr key={v.name} style={{ borderTop: '1px solid var(--border)' }}>
                <td style={cell}>
                  <strong>{v.name}</strong>
                  {v.source && <InfoIcon href={v.source} label={`Official admissions page for ${v.name}. Always verify current cycle — requirements update yearly.`} />}
                  {v.gcse && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>GCSE: {v.gcse}</div>}
                </td>
                <td style={cell}>{qual === 'alevel' ? v.alevels : ibLabel(v.ib)}</td>
                <td style={cell}>{v.ucat}</td>
                <td style={cell}>
                  {v.chem && <span style={{ marginRight: 6 }}>Chem</span>}
                  {v.bio && <span>Bio</span>}
                </td>
                <td style={cell}><VerdictPill verdict={v.verdict} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>

      <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 14 }}>
        A-level, IB and subject requirements are taken from each university's official admissions page — tap the <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 14, height: 14, borderRadius: '50%', border: '1px solid var(--border-strong)', color: 'var(--text-muted)', fontSize: 10, fontStyle: 'italic', fontFamily: 'Georgia, serif', verticalAlign: 'middle' }}>i</span> next to each school to open the source. UCAT cutoffs are aggregated by Medic Mind from prior-cycle data. Contextual offers can drop the threshold by a full grade for widening-participation applicants. Always verify on the official page before applying.
      </p>

    </>
  );
}

function SegmentBtn({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        borderRadius: 999, border: `1px solid ${active ? 'var(--brand-purple)' : 'var(--border)'}`,
        background: active ? 'var(--brand-purple)' : '#fff',
        color: active ? '#fff' : 'var(--text-2)',
        transition: 'all 150ms ease'
      }}
    >{children}</button>
  );
}

function GradeSelect({ label, value, onChange }) {
  return (
    <div>
      <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-2)' }}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={{ width: '100%', padding: '10px 12px', fontSize: 16, fontWeight: 600, border: '1px solid var(--border-strong)', borderRadius: 10, marginTop: 6, background: '#fff' }}>
        {Object.keys(gradeMap).map((g) => <option key={g} value={g}>{g}</option>)}
      </select>
    </div>
  );
}

function IbHlSelect({ label, value, onChange }) {
  return (
    <div>
      <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-2)' }}>{label}</label>
      <select value={value} onChange={(e) => onChange(Number(e.target.value))} style={{ width: '100%', padding: '10px 12px', fontSize: 16, fontWeight: 600, border: '1px solid var(--border-strong)', borderRadius: 10, marginTop: 6, background: '#fff' }}>
        {[7, 6, 5, 4, 3, 2, 1].map((g) => <option key={g} value={g}>{g}</option>)}
      </select>
    </div>
  );
}

function Toggle({ label, on, onChange }) {
  return (
    <button
      onClick={() => onChange(!on)}
      style={{
        padding: '10px 16px',
        borderRadius: 999,
        border: `1px solid ${on ? 'var(--brand-purple)' : 'var(--border)'}`,
        background: on ? 'var(--accent-soft)' : '#fff',
        color: on ? 'var(--brand-deep)' : 'var(--text-2)',
        fontWeight: on ? 600 : 500,
        fontSize: 14,
        display: 'flex', alignItems: 'center', gap: 8
      }}
    >
      {on ? <Check width="14" height="14" /> : <X width="14" height="14" />}
      {label}
    </button>
  );
}

function NumberField({ label, value, onChange, max }) {
  return (
    <div>
      <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-2)' }}>{label}</label>
      <input
        type="number"
        min="0" max={max} value={value}
        onChange={(e) => onChange(Math.max(0, Math.min(max, Number(e.target.value) || 0)))}
        style={{ width: '100%', padding: '10px 12px', fontSize: 16, fontWeight: 600, border: '1px solid var(--border-strong)', borderRadius: 10, marginTop: 6, background: '#fff' }}
      />
    </div>
  );
}

function VerdictPill({ verdict }) {
  const colours = {
    Eligible: { bg: '#e7f7ef', fg: 'var(--live-green)', bd: 'rgba(16, 185, 129, 0.35)' },
    Borderline: { bg: '#fef3c7', fg: '#b45309', bd: '#fde68a' },
    'UCAT too low': { bg: '#fef3c7', fg: '#b45309', bd: '#fde68a' },
    'Grades short': { bg: '#fee2e2', fg: '#b91c1c', bd: '#fecaca' },
    'IB score short': { bg: '#fee2e2', fg: '#b91c1c', bd: '#fecaca' },
    'Missing subject': { bg: '#fee2e2', fg: '#b91c1c', bd: '#fecaca' }
  };
  const c = colours[verdict] || colours.Borderline;
  return <span style={{ display: 'inline-block', padding: '4px 10px', borderRadius: 999, background: c.bg, color: c.fg, border: `1px solid ${c.bd}`, fontSize: 12, fontWeight: 700 }}>{verdict}</span>;
}

const cellHead = { padding: '12px 14px', textAlign: 'left', fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700 };
const cell = { padding: '12px 14px', fontSize: 14, verticalAlign: 'top' };

function InfoIcon({ href, label }) {
  return (
    <a
      href={href} target="_blank" rel="noopener noreferrer" title={label}
      aria-label={label}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 16, height: 16, marginLeft: 6, borderRadius: '50%',
        border: '1px solid var(--border-strong)', color: 'var(--text-muted)',
        fontSize: 11, fontWeight: 700, fontStyle: 'italic', fontFamily: 'Georgia, serif',
        textDecoration: 'none', lineHeight: 1, verticalAlign: 'middle',
        cursor: 'help', background: '#fff'
      }}
      onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--brand-purple)'; e.currentTarget.style.borderColor = 'var(--brand-purple)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.borderColor = 'var(--border-strong)'; }}
    >i</a>
  );
}
